import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowOutOfBox: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowOutOfBox"><Path d="M12 15.5L12 4M16.5 8L12 3.5L7.5 8M20.5 14.5V20.5H3.5V14.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowOutOfBox;
